import { render, staticRenderFns } from "./asset-location.vue?vue&type=template&id=391d784f&scoped=true&"
import script from "./asset-location.js?vue&type=script&lang=js&"
export * from "./asset-location.js?vue&type=script&lang=js&"
import style0 from "./asset-location.scss?vue&type=style&index=0&id=391d784f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391d784f",
  null
  
)

export default component.exports